import React, {Fragment, useEffect, useState} from "react";
import Breadcrumb from "../../../layout/breadcrumb";
import {Card, CardBody, Col, Container, Row, Button, UncontrolledTooltip} from "reactstrap";
import CommonDataTable from "../../../share-components/table/commonDataTable";
import {useDispatch, useSelector} from "react-redux";
import {
    getPurchaseInvoiceReportData,
    selectpurchaseInvoiceReport,
    exportInvoiceDetailReport,
    handleXeroUpload
} from "./store/citygoddessPurchaseReportSlice";
import withReducer from "../../../store/withReducer";
import reportReducer from "../index";
import moment from "moment";
import DateRangePickerDefault from "../../../share-components/ui/DateRangePickerDefault";
import {toast} from "react-toastify";



const CitygoddessPurchaseReport = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const start_date=queryParams.get("start_date");
    const end_date=queryParams.get("end_date");

    const dispatch = useDispatch();
    const [page,setPage]=useState(1);
    const [loading, isSetLoading] = useState(false);
    const [tableLoading, isSetTableLoading] = useState(false);
    const purchaseReportState = useSelector(({report}) => report.citygoddessPurchaseReport);
    const purchaseReport = useSelector(selectpurchaseInvoiceReport);
    const [pageSize, setPageSize] = useState(10)
    const [exportLoadingMap, setExportLoadingMap] = useState({});

    const [dateRange, setDateRange] = useState([null, null]);

    const [startDate, endDate] = dateRange;
    const [isUploading, setIsUploading] = useState(false);
    const [uploadedMap, setUploadedMap] = useState({});

    const dataMenu = [
        {
            type: 0,
            text: 'Purchase Invoices - CityGoddess',
        }
    ];

    const exportRow = async (row) => {
        if (!row || exportLoadingMap[row.id]) return;
        setExportLoadingMap(prev => ({ ...prev, [row.id]: true }));
        try {
            // const params = { invoiceId: row.id }
            dispatch(exportInvoiceDetailReport(row.id)).then((res) => {
                // console.log('url',res);
                const link = document.createElement("a");
                link.href = res.payload.response;
                link.setAttribute("download", "");
                document.body.appendChild(link);
                link.click();
                link.remove();
            });
        } catch (err) {
            // handle error if needed
            console.error("Export failed for invoice", row.id, err);
        } finally {
            // keep button disabled briefly to show spinner; remove after short delay
            setTimeout(() => {
                setExportLoadingMap(prev => {
                    const copy = { ...prev };
                    delete copy[row.id];
                    return copy;
                });
            }, 1500);
        }
    };

    const viewInvoice = (id) => {
        window.open(`${process.env.PUBLIC_URL}/report/citygoddess/purchase-report/${id}`);
    }

    const formatNumber = (val) => {
        return Number(val || 0).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };

    const formatNumberOnly = (value) => {
        const num = Number(value || 0);

        return num.toLocaleString("en-US", {
            minimumFractionDigits: num % 1 === 0 ? 0 : 2,
            maximumFractionDigits: 2,
        });
    };

    const handleUpload = (row) => {
        // Implement upload logic here, e.g., dispatch an action to upload the invoice to Xero
        setIsUploading(true);
            console.log(row.id);
        dispatch(handleXeroUpload(row.id)).then((res) => {
            setIsUploading(false);
            console.log('Upload response:', res);
            if(res.payload.response.code === '200'){
                // mark this invoice as uploaded
                setUploadedMap(prev => ({ ...prev, [row.id]: true }));
                toast.success("Invoice uploaded to Xero successfully");
            } else {
                toast.error("Failed to upload invoice to Xero");
            }
            // setUploaded(true);
        }).catch(err => {
            setIsUploading(false);
            toast.error("Error uploading invoice");
        });
        console.log("Upload invoice with ID:", row.id);
    }


    const tableColumns = [
        {
            name: <span title="Invoice Date">Invoice Date</span>,
            selector: row => row.invoice_date,
            sortable: true,
            center: false,

        }, 
        {
            name: <span title="Transaction Date">Transaction Date</span>,
            selector: row => <span title={`${row.order_start_date} - ${row.order_end_date}`}>{row.order_start_date} - {row.order_end_date}</span>,
            sortable: true,
            left: true,
            grow: 1.8
        },
        {
            name: <span title="Ordered Quantity">Ordered Qty</span>,
            selector: row => formatNumberOnly(row.total_ordered_qty),
            sortable: true,
            left: true,
        },
        {
            name: <span title="Returned Quantity">Returned Qty</span>,
            selector: row => formatNumberOnly(row.total_returned_qty),
            sortable: true,
            right: true,
        },
        {
            name: <span title="Net Quantity">Net Qty</span>,
            selector: row => formatNumberOnly(row.total_net_qty),
            sortable: true,
            right: true,
        },
        {
            name: <span title="Total Cost (₹)">Total Cost (₹)</span>,
            selector: row => formatNumber(row.total_cost),
            sortable: true,
            right: true,

        },
        {
            name: <span title="Tax (₹)">Tax (₹)</span>,
            selector: row => formatNumber(row.total_tax),
            sortable: true,
            right: true,

        },
        {
            name: <span title="Net Amount (₹)">Net Amount (₹)</span>,
            selector: row => formatNumber(row.total_cost_with_tax),
            sortable: true,
            right: true,

        },
         {
            name: <span title="Xero Status">Xero Status</span>,
            selector: row => row.xero_status,
            sortable: true,
            right: true,

        },
        {
                name: 'Actions',
                selector: row => {
                    const isLoading = !!exportLoadingMap[row.id];
                    return (
                        <div className="text-right">
                            <Button
                                id={`uploadInvoice-${row.id}`}
                                size="xs"
                                color="warning"
                                className="mr-2"
                                disabled={isUploading}
                                onClick={() => handleUpload(row)}
                            >
                                {isUploading ? <i className="fa fa-spinner fa-spin mr-1"></i> : 
                                <i className="fa fa-refresh mr-1"></i>}
                            </Button>
                            <UncontrolledTooltip placement="top" target={`uploadInvoice-${row.id}`}>
                                Upload Invoice to xero
                            </UncontrolledTooltip>

                            <Button
                                id={`viewInvoice-${row.id}`}
                                size="xs"
                                color="info"
                                className="mr-2"
                                // disabled={isLoading}
                                onClick={() => viewInvoice(row.id)}
                            >
                               <i className="fa fa-eye mr-1"></i>
                                
                            </Button>
                            <UncontrolledTooltip placement="top" target={`viewInvoice-${row.id}`}>
                                View Invoice Items
                            </UncontrolledTooltip>

                            <Button
                                id={`exportInvoice-${row.id}`}
                                size="xs"
                                color="primary"
                                disabled={isLoading}
                                onClick={() => exportRow(row)}
                            >
                                {isLoading ? <i className="fa fa-spinner fa-spin mr-1"></i> : <i className="fa fa-download mr-1"></i>}
                                
                            </Button>
                            <UncontrolledTooltip placement="top" target={`exportInvoice-${row.id}`}>
                                Export Invoice Details
                            </UncontrolledTooltip>
                        </div>
                    );
                },
                right: true,
                grow: 1.5,
            },
    ];



    useEffect(() => {
        getData();
    }, [startDate, endDate,page, pageSize,dispatch]);

    const pagination = (e) => {
        setPageSize(e)
    }


    const getData = () =>{
        isSetTableLoading(true);
        const data = { page, pageSize };
        if (startDate !== null && endDate !== null) {
            data.start_date = moment(startDate).format('YYYY-MM-DD');
            data.end_date = moment(endDate).format('YYYY-MM-DD');
        }
        dispatch(getPurchaseInvoiceReportData(data)).then(res => {
            if (!res.error) {
                isSetLoading(false);
            }
            isSetTableLoading(false);
        });
    }


    return (
        <Fragment>
            {loading ? <></>: <>
                <Breadcrumb title="Purchase Invoices - CityGoddess" data={dataMenu}/>
                <Container fluid={true} className="product-wrapper">
                    <div className="product-grid">
                        <div className="feature-products">
                            <Card className="px-3 mb-3">
                                <CardBody>
                                    <Row>
                                        <Col md="6">
                                            <DateRangePickerDefault
                                                dateRange={dateRange}
                                                dateRangeChange={(date) => {
                                                    setDateRange(date === null ? [null, null] : date);
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                            <Row>
                                <Col className="mt-4" sm="12">
                                    <Card>
                                        <CardBody>
                                            <div className="table-responsive product-table">
                                                <CommonDataTable
                                                    headerColumns={tableColumns}
                                                    gridData={purchaseReport}
                                                    paginationServer
                                                    paginationTotalRows={purchaseReportState.purchaseInvoiceTableRow}
                                                    noAction
                                                    fixedHeader
                                                    fixedHeaderScrollHeight="600px"
                                                    onChangePage={page => setPage(page)}
                                                    onChangeRowsPerPage={pagination}
                                                />
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                    </div>

                </Container>
            </>}
        </Fragment>
    );
}

export default withReducer([{report: reportReducer}]) (CitygoddessPurchaseReport);